// extracted by mini-css-extract-plugin
export default {"forgot_password":"Login_forgot_password__hiyGQ","login_form_button":"Login_login_form_button__pzEuL","Left":"Login_Left__8hQCH","ContactUs":"Login_ContactUs__XXquz"};